module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "yu-currency",
    attrs: {
      "data-com": "YuCurrency"
    }
  }, [(_vm.val < 0) ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v(" "), (_vm.symbol) ? _c('i', {
    staticClass: "yu-currency-symbol"
  }, [_vm._v(_vm._s(_vm.symbol))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(Math.abs(_vm.val / 100).toFixed(_vm.decimal)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bf81358","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/YouUI/Currency/Currency.vue
// module id = 281
// module chunks = 0